import * as _ from 'lodash';

export function coalesce<T>(...items: T[]) {
  return _.find(items, (it) => it != null);
}
export default coalesce;
